/* Built by Alpas Made. */
/*
 * Membership dashboard. Fetches GET /apps/credits/dashboard (Shopify
 * authenticates it through the App Proxy) and renders Your Credits + Recent
 * Activity (one block) and My Library. Re-downloading an owned file calls the
 * redeem endpoint, which is free for an already-owned item. Text is rendered
 * with textContent (never innerHTML) so product titles cannot inject markup;
 * the only attribute set from data is an <img> src (a URL, not markup).
 */
(function () {

  // Start a download without navigating. location.assign works for ONE file, but
  // a second assign cancels the first request in most browsers - an anchor click
  // per file lets the product file AND the file guide both arrive.
  function triggerDownload(url) {
    var a = document.createElement('a');
    a.href = url;
    a.rel = 'noopener';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { document.body.removeChild(a); }, 1000);
  }
  function el(tag, className, text) {
    var n = document.createElement(tag);
    if (className) n.className = className;
    if (text != null) n.textContent = text;
    return n;
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    } catch (e) {
      return d.toISOString().slice(5, 10);
    }
  }

  /*
   * Plain English for every row. The default branch used to print the raw
   * reason code, so a credit pack purchase showed up as "credit_pack", and
   * renewals were hardcoded to "Monthly" which read as a lie on the first
   * annual subscription.
   */
  function historyLabel(item) {
    switch (item.reason) {
      case 'signup':
      case 'renewal':
        if (item.plan === 'annual') return 'Annual membership renewal';
        if (item.plan === 'monthly') return 'Monthly membership renewal';
        // Rows written before the plan was recorded. Neutral rather than a
        // guess: claiming "Monthly" on an annual grant is how this got noticed.
        return 'Membership renewal';
      case 'credit_pack':
        // delta is exactly the credits granted, including a multi-quantity
        // line, so it says what actually landed rather than the pack name.
        return item.delta > 0
          ? 'Credit pack, ' + item.delta + (item.delta === 1 ? ' credit' : ' credits')
          : 'Credit pack';
      case 'redeem':
        return item.title ? 'Downloaded ' + item.title : 'Template download';
      case 'refund':
        return item.delta < 0
          ? 'Refunded, ' + Math.abs(item.delta) + (item.delta === -1 ? ' credit' : ' credits') + ' returned'
          : 'Refund';
      case 'admin_adjust':
        return 'Adjustment';
      default:
        // Never show a raw reason code to a member again.
        return 'Activity';
    }
  }

  // Copy must match what the server actually enforces: a non-member is refused
  // a NEW redeem (403 not_a_member) but may still re-download anything already
  // owned. Credits are never zeroed, they sit dormant until the member
  // re-subscribes, so we must not imply a use-by deadline or any forfeiture.
  /*
   * A MEMBER WHO CANCELLED IS NOT "ACTIVE", so they must not see a green
   * chip that says so. Their status really is
   * 'active' until the period runs out, so the status alone cannot tell the
   * two apart: the second argument is what does.
   *
   * cancelScheduled is THREE valued. Only an explicit true means cancelled;
   * null means we could not ask Seal, and a null must never be read as false,
   * because telling somebody their membership renews when they have cancelled
   * it is a promise the system cannot keep.
   */
  function statusInfo(status, cancelScheduled) {
    if (status === 'active' && cancelScheduled === true) {
      return {
        pill: 'Ending',
        cls: 'ending',
        note: 'Your membership is set to end, so it will not renew. Your credits stay on your account after it ends, and files you already downloaded stay yours to re-download.',
        cta: 'Reactivate my membership'
      };
    }
    switch (status) {
      case 'grace':
        return {
          pill: 'Payment issue',
          cls: 'grace',
          note: 'You cannot spend credits until your next payment goes through. Your credits are safe and your downloaded files still work.',
          cta: 'Update payment method'
        };
      case 'cancelled':
        return {
          pill: 'Ended',
          cls: 'cancelled',
          note: 'Your membership has ended, so your credits cannot be spent right now. They stay saved on your account and become available again as soon as you reactivate. Files you already downloaded are still yours to re-download.',
          cta: 'Reactivate my membership'
        };
      default:
        return { pill: 'Active', cls: 'active', note: '', cta: '' };
    }
  }

  // `append` adds a page below what is already rendered (the "Show more"
  // path). The ledger is append-only and never pruned, so a long-standing
  // member's activity list would otherwise grow without limit.
  function renderHistory(listEl, emptyEl, history, append) {
    if (!append) listEl.textContent = '';
    if (!history || history.length === 0) {
      if (!append) emptyEl.hidden = false;
      return;
    }
    emptyEl.hidden = true;
    history.forEach(function (h) {
      var li = el('li');
      li.appendChild(el('span', 'credit-dashboard__txn-date', formatDate(h.at)));
      li.appendChild(el('span', 'credit-dashboard__txn-what', historyLabel(h)));
      var amt = h.delta > 0 ? '+' + h.delta : String(h.delta);
      li.appendChild(el('span', 'credit-dashboard__txn-right credit-dashboard__txn-amt--' + (h.delta >= 0 ? 'pos' : 'neg'), amt));
      listEl.appendChild(li);
    });
  }

  function renderLibrary(listEl, emptyEl, library, redeemUrl) {
    listEl.textContent = '';
    if (!library || library.length === 0) { emptyEl.hidden = false; return; }
    emptyEl.hidden = true;
    library.forEach(function (item) {
      var li = el('li');
      if (item.image) {
        var img = document.createElement('img');
        img.className = 'credit-dashboard__thumb';
        img.src = item.image; img.alt = ''; img.loading = 'lazy';
        img.width = 54; img.height = 54;
        li.appendChild(img);
      } else {
        li.appendChild(el('span', 'credit-dashboard__thumb'));
      }
      li.appendChild(el('span', 'credit-dashboard__lib-title', item.title || 'Template'));
      // Real per-item file count from the API (design file + guide today), so
      // the label never claims a number the server did not report. Older cached
      // payloads without `files` just render the plain label.
      var label = 'Download again';
      if (typeof item.files === 'number' && item.files > 0) {
        label += ' (' + item.files + (item.files === 1 ? ' file)' : ' files)');
      }
      var btn = el('button', 'credit-dashboard__dl', label);
      btn.type = 'button';
      btn.addEventListener('click', function () { reDownload(btn, item.productId, redeemUrl); });
      li.appendChild(btn);
      listEl.appendChild(li);
    });
  }

  function reDownload(btn, productId, redeemUrl) {
    if (btn.disabled) return;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Preparing...';
    fetch(redeemUrl || '/apps/credits/redeem', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ product_id: productId })
    })
      .then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d || {} }; }, function () { return { status: r.status, data: {} }; }); })
      .then(function (r) {
        if (r.status === 200 && r.data.ok && r.data.downloadUrl) {
          // Same popup as the product page. If this surface kept the old
          // two-automatic-downloads behaviour, a member re-downloading later
          // would still receive one file of three.
          if (window.KCDownloadPopup && r.data.files && r.data.files.length) {
            window.KCDownloadPopup.open({
              files: r.data.files,
              charged: r.data.charged,
              alreadyOwned: r.data.alreadyOwned,
              expiresIn: r.data.filesExpiresIn || r.data.expiresIn,
              title: btn.getAttribute('data-title') || ''
            });
          } else {
            triggerDownload(r.data.downloadUrl);
            if (r.data.guideUrl) setTimeout(function () { triggerDownload(r.data.guideUrl); }, 600);
          }
          btn.textContent = original;
        } else {
          btn.textContent = 'Try again';
        }
        btn.disabled = false;
      })
      .catch(function () { btn.textContent = 'Try again'; btn.disabled = false; });
  }

  function renderUpsell(root, loading) {
    if (loading) loading.hidden = true;
    var url = root.getAttribute('data-membership-url') || '/pages/membership';
    var wrap = el('div', 'credit-dashboard__card credit-dashboard__upsell');
    wrap.appendChild(el('h2', 'credit-dashboard__h2', 'You are not a member yet'));
    wrap.appendChild(el('p', 'credit-dashboard__signin', 'Join to download templates with monthly credits, plus the full library and member tools.'));
    var a = document.createElement('a');
    a.className = 'button button--primary button--fixed w-full';
    a.href = url;
    a.appendChild(el('span', 'btn-text', 'Become a member'));
    wrap.appendChild(a);
    root.appendChild(wrap);
  }

  function init(root) {
    var content = root.querySelector('[data-cd-content]');
    if (!content) return; // logged-out markup, nothing to fetch
    var loading = root.querySelector('[data-cd-loading]');
    var errorEl = root.querySelector('[data-cd-error]');
    var endpoint = root.getAttribute('data-endpoint') || '/apps/credits/dashboard';
    var redeemUrl = root.getAttribute('data-redeem-url') || '/apps/credits/redeem';
    var billingUrl = root.getAttribute('data-billing-url') || '';

    function showError(msg) {
      if (loading) loading.hidden = true;
      if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
    }

    // ---- activity paging ------------------------------------------------
    var moreBtn = root.querySelector('[data-cd-history-more]');
    var historyLoaded = 0;
    var historyTotal = 0;

    function syncMoreBtn() {
      if (!moreBtn) return;
      moreBtn.hidden = historyLoaded >= historyTotal;
      moreBtn.disabled = false;
      moreBtn.textContent = 'Show older activity';
    }

    function loadMoreHistory() {
      if (!moreBtn || moreBtn.disabled) return;
      moreBtn.disabled = true;
      moreBtn.textContent = 'Loading...';
      var sep = endpoint.indexOf('?') === -1 ? '?' : '&';
      fetch(endpoint + sep + 'history_offset=' + historyLoaded, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(function (r) {
          return r.json().then(
            function (d) { return { status: r.status, data: d || {} }; },
            function () { return { status: r.status, data: {} }; }
          );
        })
        .then(function (r) {
          if (r.status !== 200 || !r.data.ok) {
            // Leave what is already on screen: a failed extra page must not
            // blank the activity the member can already see.
            moreBtn.disabled = false;
            moreBtn.textContent = 'Could not load more, tap to retry';
            return;
          }
          var page = r.data.history || [];
          renderHistory(
            root.querySelector('[data-cd-history]'),
            root.querySelector('[data-cd-history-empty]'),
            page,
            true
          );
          historyLoaded += page.length;
          if (typeof r.data.historyTotal === 'number') historyTotal = r.data.historyTotal;
          // A page that comes back empty means we have reached the end even if
          // the total disagrees, so stop offering more rather than looping.
          if (page.length === 0) historyTotal = historyLoaded;
          syncMoreBtn();
        })
        .catch(function () {
          moreBtn.disabled = false;
          moreBtn.textContent = 'Could not load more, tap to retry';
        });
    }

    if (moreBtn) moreBtn.addEventListener('click', loadMoreHistory);

    fetch(endpoint, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d || {} }; }, function () { return { status: r.status, data: {} }; }); })
      .then(function (r) {
        if (r.status !== 200 || !r.data.ok) {
          showError('We could not load your membership right now. Please refresh and try again.');
          return;
        }
        var d = r.data;
        if (d.member === false) { renderUpsell(root, loading); return; }

        root.querySelector('[data-cd-balance]').textContent = d.balance;

        /*
         * Top-up is offered ONLY to an active membership. The server refuses a
         * pack bought by a non-member and flags the order for a refund, so
         * showing these to someone in grace or cancelled would be selling them
         * something that gets taken back. Their route is the CTA below, which
         * already points at reactivating. The rule itself lives in
         * kc-credit-rules.js, shared with the product page; without it, no packs.
         */
        var topup = root.querySelector('[data-cd-topup]');
        if (topup) topup.hidden = !(window.KCCreditRules && window.KCCreditRules.packsAllowed(d));

        /*
         * Correct the partner code if the page was served from cache.
         *
         * The code is rendered SERVER-SIDE from the customer metafield, on
         * purpose, so it survives this fetch failing. The cost of that is that
         * Shopify can serve a cached page carrying a code that has since
         * rotated or been revoked, and the member then takes a dead code to
         * HCT and concludes the discount is broken: a cached first load can
         * show the old code while a later load shows the new one.
         *
         * So the server render stays as the resilient default, and the live
         * value from the payload overrides it whenever the two disagree.
         * Codes rotate, so `hctDiscount` is the authority when we have it.
         */
        var codeEl = root.querySelector('[data-hct-code]');
        if (codeEl) {
          var live = d.hctDiscount && d.hctDiscount.code ? String(d.hctDiscount.code) : null;
          var shown = (codeEl.textContent || '').trim();
          if (live && live !== shown) {
            codeEl.textContent = live;
            var copyBtn = root.querySelector('[data-hct-copy]');
            if (copyBtn) copyBtn.setAttribute('aria-label', 'Copy discount code ' + live);
          } else if (!live && shown) {
            // Revoked while a cached page still shows it. Hide the whole card
            // rather than leave a dead code sitting there looking usable.
            var card = codeEl.closest('.credit-dashboard__hct');
            if (card) card.hidden = true;
          }
        }

        var info = statusInfo(d.status, d.cancelScheduled);
        var pill = root.querySelector('[data-cd-pill]');
        if (pill) { pill.textContent = info.pill; pill.className = 'credit-dashboard__pill credit-dashboard__pill--' + info.cls; pill.hidden = false; }

        /*
         * What the membership is doing, and until when.
         *
         *   ended                 -> "Membership ended Aug 30"
         *   cancelled, still paid -> "Membership cancelled, active until Oct 9"
         *   confirmed renewing    -> "Membership active, renews Oct 9"
         *   cannot confirm which  -> "Membership active until Oct 9"
         *
         * That last line is the important one. cancelScheduled is THREE valued:
         * true, false, or null meaning the server could not ask Shopify. Null
         * must never be read as false, because "renews" said to someone who has
         * cancelled is a promise the system cannot keep. The neutral wording is
         * true either way, so an unreachable Shopify degrades the sentence
         * rather than making it wrong.
         *
         * Our own status cannot tell these apart: it reads active right up to
         * the day a membership lapses. Only Shopify knows, and the daily sweep
         * asks it.
         */
        var periodEl = root.querySelector('[data-cd-period]');
        if (periodEl) {
          var ends = d.periodEnd ? new Date(d.periodEnd) : null;
          var valid = ends && !isNaN(ends.getTime());
          /*
           * The date arrives already formatted, in STORE time, so it matches
           * the date Shopify shows on its own billing screen. The same
           * instant reads "Oct 3" in Los Angeles and
           * "Oct 4" in London if the browser formats it.
           */
          var when = d.periodEndLabel || '';
          if (!when && valid) {
            // Year included for the same reason the server includes it: an
            // annual member renews a year out, so a bare month and day is
            // ambiguous. This branch only runs if the server label is missing.
            when = ends.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
          }

          var line = '';
          if (when && d.status === 'cancelled') {
            line = 'Membership ended ' + when;
          } else if (when && d.status === 'active' && valid && ends.getTime() > Date.now()) {
            if (d.cancelScheduled === true) line = 'Membership cancelled, active until ' + when;
            else if (d.cancelScheduled === false) line = 'Membership active, renews ' + when;
            else line = 'Membership active until ' + when;
          }

          periodEl.textContent = line;
          periodEl.hidden = !line;
        }
        var note = root.querySelector('[data-cd-note]');
        if (note) {
          if (info.note) { note.textContent = info.note; note.className = 'credit-dashboard__note credit-dashboard__note--' + info.cls; note.hidden = false; }
          else { note.hidden = true; }
        }

        // Only blocked states get an action. Falls back to the account page when
        // no billing URL is configured, so the button is never a dead link.
        var cta = root.querySelector('[data-cd-cta]');
        if (cta) {
          if (info.cta && billingUrl) {
            cta.textContent = info.cta;
            cta.setAttribute('href', billingUrl);
            cta.hidden = false;
          } else {
            cta.hidden = true;
            cta.removeAttribute('href');
          }
        }

        // The way out for an active member. Shown exactly when the button above
        // is not, so there is never a second link to the same billing screen.
        var manage = root.querySelector('[data-cd-manage]');
        if (manage) manage.hidden = Boolean(info.cta) || !billingUrl;

        renderHistory(root.querySelector('[data-cd-history]'), root.querySelector('[data-cd-history-empty]'), d.history, false);
        historyLoaded = (d.history || []).length;
        historyTotal = typeof d.historyTotal === 'number' ? d.historyTotal : historyLoaded;
        syncMoreBtn();
        renderLibrary(root.querySelector('[data-cd-library]'), root.querySelector('[data-cd-library-empty]'), d.library, redeemUrl);

        var count = root.querySelector('[data-cd-count]');
        // Counts DESIGNS, not files: each row carries its own file count and
        // they differ, so summing them here would be a third number on a page
        // that already had two that disagreed.
        if (count) { var n = (d.library || []).length; count.textContent = n + (n === 1 ? ' design' : ' designs'); }

        if (loading) loading.hidden = true;
        content.hidden = false;
      })
      .catch(function () { showError('We could not load your membership right now. Please refresh and try again.'); });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-credit-dashboard]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
